import { CSSProperties } from 'react';
import { IconType } from '.';

interface CartProps extends IconType {
  style?: CSSProperties;
}

export default function Cart({ color = '#000000', className = '', height = 14.344, style, width = 16 }: CartProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 14.344" style={style} className={className}>
      <path
        id="cart-shopping-regular"
        fill={color}
        d="M.672,0a.672.672,0,0,0,0,1.345H1.947a.227.227,0,0,1,.221.182L3.614,9.119a2.017,2.017,0,0,0,1.981,1.639h8.077a.672.672,0,1,0,0-1.345H5.595a.675.675,0,0,1-.661-.546l-.151-.8h8.082a2.012,2.012,0,0,0,1.947-1.493L15.96,2.308A1.12,1.12,0,0,0,14.879.9H3.365A1.566,1.566,0,0,0,1.947,0Zm3,2.241H14.588L13.515,6.225a.672.672,0,0,1-.65.5H4.527Zm1.258,12.1A1.345,1.345,0,1,0,3.586,13,1.345,1.345,0,0,0,4.931,14.344ZM14.344,13A1.345,1.345,0,1,0,13,14.344,1.345,1.345,0,0,0,14.344,13Z"
      />
    </svg>
  );
}
